import React, { useCallback } from 'react';
import { Radio } from 'antd';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { safeExtractFromObject } from '../../helpers/helpers';

export default function OnTraccrRadioGroup({
  onChange,
  defaultValue,
  options = [],
  buttonStyle,
  value,
  style,
  children,
  isDisplay = false,
  className = '',
}) {
  const settings = useSelector((state) => safeExtractFromObject(state, 'settings.company.settings'));

  const onRadioChange = useCallback((e) => {
    const { target: { value: newValue } = {} } = e;
    onChange(newValue);
  }, [onChange]);

  if (isDisplay) {
    const selectedOption = options.find((option) => option.value === value);
    return (
      <div style={{ fontSize: 14, color: 'rgba(0, 0, 0, 0.65)' }}>
        {selectedOption ? selectedOption.label : 'None'}
      </div>
    );
  }

  return (
    <Radio.Group
      buttonStyle={buttonStyle}
      onChange={onRadioChange}
      defaultValue={defaultValue}
      className={[
        settings?.uxRedesignPt1 ? 'ontraccr-radio-group' : '',
        className,
      ]}
      value={value}
      style={style}
      options={options}
    >
      {children}
    </Radio.Group>
  );
}

OnTraccrRadioGroup.propTypes = {
  onChange: PropTypes.func.isRequired,
  defaultValue: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })),
  buttonStyle: PropTypes.string,
  value: PropTypes.string,
  style: PropTypes.shape({}),
  children: PropTypes.node,
  isDisplay: PropTypes.bool,
  className: PropTypes.string,
};

OnTraccrRadioGroup.defaultProps = {
  defaultValue: '',
  options: [],
  buttonStyle: 'outline',
  value: null,
  style: {},
  isDisplay: false,
};
